<template>
    <div class="projects-details-area ptb-100">
        <div class="container">
            <div class="projects-details-desc">
                <div class="article-projects-with-info">
                    <div class="row align-items-center">
                        <div class="col-lg-7 col-md-6">
                            <div class="projects-info-image">
                                <img src="../../assets/images/projects-details/projects-details-1.jpg" alt="image">

                                <div class="info-shape">
                                    <img src="../../assets/images/projects-details/circle-shape.png" alt="image">
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-5 col-md-6">
                            <div class="projects-info-content">
                                <span>PROJECT DETAILS</span>
                                <h3>Messaging App</h3>

                                <ul class="info-list">
                                    <li><span>Category:</span> App Development</li>
                                    <li><span>Client:</span> Solit IT Group</li>
                                    <li><span>Duration:</span> August 2020 - January 2022</li>
                                    <li><span>Location:</span> Australia</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="article-projects-content">
                    <div class="row align-items-center">
                        <div class="col-lg-6 col-md-6">
                            <div class="content">
                                <h3>Problems We Faced</h3>
                                <p>Lorem ipsum dolor sit amet consetetur sadip scing elitr sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyamei erat sed diam voluptua at vero eos et accusam et justo duo.</p>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <div class="image">
                                <img src="../../assets/images/projects-details/projects-details-2.jpg" alt="image">
                            </div>
                        </div>
                    </div>
                    <ul class="projects-list">
                        <li>
                            <h4>Our Steps To Solve The Problems</h4>
                        </li>
                        <li><i class="ri-checkbox-circle-line"></i> Lorem ipsum dolor sit amet consetetur sadipscing elitr sed diam nonumy eirmod tempor invidunt ut</li>
                        <li><i class="ri-checkbox-circle-line"></i> Dolor sit amet consetetur sadipscing elitr sed diam nonumy eirmod tempor invidunt.</li>
                        <li><i class="ri-checkbox-circle-line"></i> Consetetur sadipscing elitr sed diam nonumy eirmod tempor invidunt.</li>
                        <li><i class="ri-checkbox-circle-line"></i> Sadipscing elitr sed diam nonumy eirmod tempor invidunt ut labore dolore magna aliquyam erat.</li>
                        <li><i class="ri-checkbox-circle-line"></i> Sed diam nonumy eirmod tempor invidunt ut labore dolore magna aliquyam erat.</li>
                    </ul>
                </div>
                <div class="article-projects-image">
                    <img src="../../assets/images/projects-details/projects-details-3.jpg" alt="image">
                </div>
                <div class="article-projects-text">
                    <h3>How We Achieve Success</h3>
                    <p>Lorem ipsum dolor sit amet consetetur sadipscing elitr sed diam nonumy eirmod tempor invidunt ut labore dolore magna aliquyam erat sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum steter clita kasd gubergren no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
                    <p>Lorem ipsum dolor sit amet consetetur sadipscing elitr sed diam nonumy eirmod tempor invidunt ut labore dolore magna aliquyam erat sed diam voluptua.</p>
                </div>
                <div class="article-projects-quote">
                    <i class="ri-double-quotes-l"></i>
                    <p>Lorem ipsum dolor sit amet consetetur sadipscing elitr sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat sed diam voluptua.</p>

                    <div class="quote-shape">
                        <img src="../../assets/images/projects-details/circle-shape.png" alt="image">
                    </div>
                </div>
                <div class="article-projects-text">
                    <p>Lorem ipsum dolor sit amet consetetur sadipscing elitr sed diam nonumy eirmod tempor invidunt ut labore dolore magna aliquyam erat sed diam voluptua.</p>
                </div>
            </div>
        </div>

        <div class="projects-details-shape">
            <img src="../../assets/images/projects-details/line-shape.png" alt="image">
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProjectsDetails'
}
</script>